<template>
    <div>
        <img src="../assets/img/fanhui.png" alt="" class="fanhuiBtn" @click="fanhui">
        <Swiper :swiperImg="swiperImg"></Swiper>
        <div class="jiudianjieshao">
            <p class="logo">
                <img src="../assets/img/Jiayi/logo.png" alt="">
            </p>
            <p class="oneImg">
                <video src="../assets/video/jiayi.mp4" controls poster="../assets/img/Jiayi/fengmian.png"></video>
            </p>
            <p class="wenzijieshao">
                山东文旅酒店集团旗下大众商旅品牌，自创立至今，在全国拥有300余家连锁门店，随着佳驿酒店4.0版本的上市， 全新的品牌形象焕然一新。
                佳驿4.0定位于大众商旅连锁酒店，打造安、密、净、悦、享的大众住宿五星品牌，让您真正体验家的感觉，带着憧憬而来，带着故事离开。
            </p>
            <p class="manxiang">
                <img src="../assets/img/Jiayi/yuan.png" alt="">
                <span>大众住宿的五星品牌</span>
            </p>
            <div class="photoZhanshi">
                <img src="../assets/img/Jiayi/wenzi.png" alt="" class="gaoduan">
                <div class="shishangpinzhi">
                    <div>
                        <img src="../assets/img/Jiayi/wenzi1.png" alt="">
                    </div>
                    <div>
                        <img src="../assets/img/Jiayi/wenzi2.png" alt="">
                    </div>
                </div>
                <img src="../assets/img/Jiayi/4.png" alt="" class="shengyu">
                <img src="../assets/img/Jiayi/5.png" alt="" class="shengyu">
                <img src="../assets/img/Jiayi/6.png" alt="" class="shengyu lastImg">
            </div>
        </div>
        <div class="jiamengyaoqiu">
            <p class="wuyeyaoqiu">物业要求</p>
            <div class="wuyejuti">
                <p>单房投资：6-7万/间 </p>
                <p>便利的交通条件，周边生活气息浓厚、配套设施完善</p>
                <p>产权明晰、消防验收合格</p>
                <p>客房净面积：>16平方米</p>
                <p>建筑面积：1800-5000平方米</p>
            </div>
            <p class="jiamengzhengce">加盟政策</p>
            <ul class="zhengcejuti">
                <li>
                    <span>加盟期限</span>
                    <span>10年</span>
                </li>
                <li>
                    <span>品牌加盟费</span>
                    <span>2000元/间</span>
                </li>
                <li>
                    <span>运营保证金</span>
                    <span>3万</span>
                </li>
                <li>
                    <span>品牌持续使用费</span>
                    <span>按酒店总收入3%收取</span>
                </li>
                <li class="juda">
                    <span>服务支持费</span>
                    <span>1.月出租率40%(不含)以下的,免收<br>2.月出租率40%(含)-60%(不含)之间的,按照酒店总收入的1%收取<br>3.月出租率60%(含)-80%(不含)之间的,按照酒店总收入的1.5%收取<br>4.月出租率80%(含)以上的,按照酒店总收入的2%收取</span>
                </li>
                <li class="juda">
                    <span>店长派驻费</span>
                    <span>按城市级别及房量确定每个月店长费用（专职、兼职）</span>
                </li>
                <li>
                    <span>工程督导费</span>
                    <span>2万元/店</span>
                </li>
                <li class="juda">
                    <span>系统初装及维护费</span>
                    <span>初装费1.6万元，维护费1500元/月（含AI智能管家）。</span>
                </li>
                <li>
                    <span>直销系统费用</span>
                    <span>7%</span>
                </li>
            </ul>
            <p class="tishi">特别提示：市场有风险，投资需谨慎</p>
            <div class="rexian">
                <p>135-1531-0068</p>
            </div>
            <div class="jiamengBtn">
                <button @click="jumpJoin">我要加盟</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            swiperImg: {
                url1: require('../assets/img/Jiayi/one.png'),
                url2: require('../assets/img/Jiayi/two.png'),
                url3: require('../assets/img/Jiayi/three.png'),
                url4: require('../assets/img/Jiayi/four.png'),
            }
        }
    },
    mounted() {

    },
    methods: {
        fanhui() {
            this.$router.go(-1)
        },
        jumpJoin() {
            let object = {
                banner: require('../assets/img/Join/jiayi.png'),
                yingwen: require('../assets/img/Join/jiayi1.png'),
                name: 'jiayi',
                rexian: '135-1531-0068'
            }
            sessionStorage.setItem('message', JSON.stringify(object))
            this.$router.push({ path: '/Join' })
        }
    }
}
</script>

<style lang="less" scoped>
p {
    margin: 0;
}

.fanhuiBtn {
    z-index: 1000;
    position: absolute;
    width: 48px;
    height: 48px;
    top: 20px;
    left: 20px;
}

.jiudianjieshao {
    margin: 0 30px;
    height: auto;
    padding: 0 51.5px;
    position: relative;
    margin-top: -70px;
    background-color: #ffffff;
    box-shadow: -2px -3px 16px 0px rgba(149, 127, 102, 0.33),
        3px 3px 16px 0px rgba(149, 127, 102, 0.32);
    border-radius: 10px;
    z-index: 1000;

    .logo {
        text-align: center;
        padding-top: 24px;

        img {
            width: 205px;
            height: 96px;
        }
    }

    .oneImg {
        text-align: center;
        margin-top: 24px;
        margin-bottom: 35px;

        video {
            width: 100%;
            height: 331px;
        }
    }

    .wenzijieshao {
        text-indent: 2em;
        font-family: 'pfzd';
        font-size: 28px;
        letter-spacing: 1px;
        color: #000000;
        margin-bottom: 35px;
    }

    .manxiang {
        text-align: center;
        margin-bottom: 27px;

        img {
            width: 28px;
            height: 28px;
            position: relative;
            top: -15px;
            left: 10px;
        }

        span {
            font-family: 'pfzd';
            font-size: 35px;
            color: #23b3d3;
            text-shadow: -1px -1px 0px #23b3d3, -1px -1px 0px #23b3d3;
        }
    }

    .photoZhanshi {
        .gaoduan {
            width: 100%;
        }

        .shishangpinzhi {
            margin-top: 19px;

            div {
                width: 50%;
                display: inline-block;

                img {
                    width: 282px;
                    height: 245px;
                }
            }

            div:first-child {
                text-align: left;
            }

            div:last-child {
                text-align: right;
            }
        }

        .shengyu {
            width: 100%;
            margin-top: 20px;
        }

        .lastImg {
            padding-bottom: 67px;
        }
    }
}

.jiamengyaoqiu {
    padding: 0 30px;

    .wuyeyaoqiu {
        font-family: 'pfzd';
        font-size: 40px;
        color: #199bc9;
        text-align: center;
        margin-top: 38px;
    }

    .wuyejuti {
        width: 100%;
        margin-top: 40px;

        p {
            text-align: center;
            font-family: 'pfzd';
            font-size: 26px;
            line-height: 69px;
            color: #1a274b;
            border-top: 2px solid #23b3d3;
        }

        p:last-child {
            border-bottom: 2px solid #23b3d3;
        }
    }

    .jiamengzhengce {
        font-family: 'pfzd';
        font-size: 40px;
        line-height: 69px;
        color: #199bc9;
        text-align: center;
        margin-top: 35px;
    }

    .zhengcejuti {
        width: 100%;
        height: auto;
        margin-top: 33px;

        li {
            padding: 0 21px;
            height: 69px;
            display: flex;
            align-items: center;

            span {
                display: inline-block;
                vertical-align: middle;
                font-family: 'pfzd';
                font-size: 26px;
                letter-spacing: 0px;
                color: #3a3f49;
            }

            span:first-child {
                width: 51.5%;
            }

            span:last-child {
                width: 48.5%;
            }
        }

        li:nth-of-type(odd) {
            background-color: #f2f2f2;
        }

        .juda {
            height: auto;
            padding: 25px 21px;
        }
    }

    .tishi {
        text-align: center;
        font-family: 'pfct';
        font-size: 32px;
        line-height: 69px;
        color: #1a274b;
        margin-bottom: 59px;
        margin-top: 54px;
    }

    .rexian {
        width: 580px;
        height: 114px;
        margin: 0 auto;
        background-image: url(../assets/img/Jiayi/jiameng.png);
        background-repeat: no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        text-align: center;

        p {
            font-family: 'pfct';
            font-size: 50px;
            letter-spacing: 3px;
            color: #23b3d3;
            margin: 0 auto;
            margin-top: 20px;
        }
    }

    .jiamengBtn {
        text-align: center;
        margin-top: 62px;
        margin-bottom: 80px;

        button {
            width: 583px;
            height: 80px;
            background-color: #23b3d3;
            border-radius: 10px;
            color: #ffffff;
            font-family: 'pfct';
            font-size: 32px;
            letter-spacing: 6px;
            border: none;
        }
    }
}
</style>
